import { colorsPalettes } from "@similarweb/styles";

import { rangeMap } from "../../Const";

interface IPositionsConfig {
    color: string;
    name: (typeof rangeMap)[keyof typeof rangeMap];
}

const { RANGE_1_3, RANGE_4_10, RANGE_11_20, RANGE_21_50, RANGE_GREATER_THAN_20 } = rangeMap;

export const positionsConfig: Partial<Record<(typeof rangeMap)[keyof typeof rangeMap], IPositionsConfig>> = {
    [RANGE_1_3]: {
        color: colorsPalettes.midnight[500],
        name: RANGE_1_3,
    },
    [RANGE_4_10]: {
        color: colorsPalettes.blue[500],
        name: RANGE_4_10,
    },
    [RANGE_11_20]: {
        color: colorsPalettes.blue[400],
        name: RANGE_11_20,
    },
    [RANGE_21_50]: {
        color: colorsPalettes.blue[300],
        name: RANGE_GREATER_THAN_20,
    },
};

export const WIDGET_FOOTER_KEYWORDS_LINK_TEXT = "seo.overview.ranking.distribution.graph.link.text";

export const TITLE_POSITION = "seo.overview.ranking.distribution.graph.tooltip.title.positions";
export const TITLE_KEYWORDS = "seo.overview.ranking.distribution.graph.tooltip.title.keywords";
export const TITLE_GROUP_SHARE = "seo.overview.ranking.distribution.graph.tooltip.title.group.share";
export const TITLE_CHANGE = "seo.overview.ranking.distribution.graph.tooltip.title.change";
export const TITLE_TOTAL = "seo.overview.ranking.distribution.graph.tooltip.title.total";
